import React, {
  useState,
  useEffect,
} from 'react';
import './style.css';
import {
  parse,
  stringify,
} from 'querystring';
import CategoryFilter from "./CategoryFilter";
import withRouter from "react-router/es/withRouter";
import MultiSelectFilter from './MultiSelectFilter';
import InputFilter from "./InputFilter";
import PriceFilter from "./PriceFilter";
import FilterTag from './FilterTag';
import { Checkbox } from '@material-ui/core';
import { useSelector } from 'react-redux';
import {DARK_GREY, LIGHT_GREEN, LIGHT_GREY} from '../../config/colors';
import {
  getBrands,
  getClassifications,
  getFlavors,
  getEffects,
  getGeneralAttributes,
  getSubCategories,
  getSecondaryColor
} from '../../selectors/configSelectors';
import PriceIcon from "../../icons/PriceIcon";
import PotencyIcon from "../../icons/PotencyIcon";
import EffectIcon from "../../icons/EffectIcon";
import GeneralIcon from "../../icons/GeneralIcon";
import ClassificationIcon from "../../icons/ClassificationIcon";
import Flower from "../../icons/types/Flower";
import FlavorIcon from "../../icons/FlavorIcon";
import BrandTreezIcon from "../../icons/BrandTreezIcon";
import { getSearchUri } from "../../config/uri";
import { CloseIcon } from '../../icons';
import { getCategoriesWithSubTypesByConfig } from '../../helpers/producttypes';
import { 
  OPEN_FILTER_QUERY,
  ACTIVE_FILTER_QUERY_PARAMS,
  CATEGORIES_QUERY_PARAM,
  SUB_TYPES_QUERY_PARAM,
  TYPE_SUBTYPES_QUERY_PARAM,
  MIN_THC_QUERY_PARAM,
  MAX_PRICE_QUERY_PARAM,
  CLASSIFICATIONS_QUERY_PARAM
} from './filter_constants';
import * as QueryParams from '../../const/query_params';
import { getSelectedCustomerType } from '../../selectors/customer_type_selector';
import { getSalesChannelName } from '../../selectors/sales_channel_selectors';

const STYLES = {
  closeBtn: {
    position: "absolute",
    right: 0,
    top: 0,
    cursor: "pointer",
    zIndex: 1
  },
  closeIcon: { height: "35px", width: "35px" },
  desktopContainer: { border: '1px solid #E7E7E7', borderRadius: 6, width: 300, minHeight: 1102, padding: 12, maxWidth: '100%',  transition: 'max-width 2.5s, opacity 0.2s' },
  mobileContainer: { padding: '4px 12px 12px' }
};

const CLASSIFICATIONS_ALWAYS_DISPLAYED = ['INDICA', 'SATIVA', 'HYBRID'];

const Filter = (props) => {

  const [ filters, setFilters ] = useState({});
  const [ inputFilters, setInputFilters ] = useState({});
  const [ categoryFilters, setCategoryFilters ] = useState({});
  const [ expandClassifications, setExpandClassifications ] = useState(false);
  const [ expandCategory, setExpandCategory ] = useState(false);
  const [ clearState, setClearState ] = useState(false);

  useEffect(() => {
    applyExistingFilters()
  }, []);

  const sortAsc = arr => arr.sort();
  const customerType = useSelector(state => getSelectedCustomerType(state));
  const categories = useSelector(state => getCategoriesWithSubTypesByConfig(getSubCategories(state)));
  const brands = useSelector(state => sortAsc(getBrands(state)));
  const classifications = useSelector(state => getClassifications(state));
  const flavors = useSelector(state => sortAsc(getFlavors(state)));
  const effects = useSelector(state => sortAsc(getEffects(state)));
  const generalAttributes = useSelector(state => sortAsc(getGeneralAttributes(state)));
  const secondaryColor = useSelector(state => `#${getSecondaryColor(state)}`);
  const salesChannelName = useSelector(state => getSalesChannelName(state));

  const convertToUrl = () => {
    const allFilters = {
      [OPEN_FILTER_QUERY]: [],
      [QueryParams.CUSTOMER_TYPE]: [customerType],
    };

    if (salesChannelName) {
      allFilters[QueryParams.SALES_CHANNEL_NAME] = [salesChannelName];
    }

    if (!_.isEmpty(Object.keys(categoryFilters))) {
      allFilters[CATEGORIES_QUERY_PARAM] = Object.keys(categoryFilters);
    }

    if (!_.isEmpty(Object.values(categoryFilters).flat())) {
      allFilters[SUB_TYPES_QUERY_PARAM] = Object.values(categoryFilters).flat();
    }

    allFilters[TYPE_SUBTYPES_QUERY_PARAM] = [encodeURIComponent(JSON.stringify(categoryFilters))];

    if (!_.isEmpty(Object.entries(filters))) {
      Object.entries(filters).forEach(([key, value]) => allFilters[key] = value);
    }

    if (!_.isEmpty(Object.entries(inputFilters))) {
      Object.entries(inputFilters).forEach(([key, value]) => allFilters[key] = [value]);
    }

    Object.keys(allFilters).forEach(k => allFilters[k] = allFilters[k].join(','));

    const { resetScrollPosition } = props;

    resetScrollPosition();

    props.history.push({ pathname: getSearchUri(), search: stringify (allFilters)})
  };

  const applyExistingFilters = () => {
    const urlFilter = {};
    const urlInputFilter = {};
    let parsedTypeSubtype = {};

    const filtersFromUrl = parse(props.location.search.slice(1));
    const filtered = Object.keys(filtersFromUrl);

    const multiSelectFilters = filtered.filter(key => ACTIVE_FILTER_QUERY_PARAMS.indexOf(key) >= 0);
    multiSelectFilters.forEach(filter => {
      urlFilter[filter] = filtersFromUrl[filter].split(',');
    });

    const inputFilters = filtered.filter(key => key === MIN_THC_QUERY_PARAM || key === MAX_PRICE_QUERY_PARAM);
    inputFilters.forEach(filter => {
      urlInputFilter[filter] = filtersFromUrl[filter]
    });

    const typeAndSubtypeFilters = filtersFromUrl[TYPE_SUBTYPES_QUERY_PARAM];

    if (typeof typeAndSubtypeFilters !== 'undefined') {
      parsedTypeSubtype = JSON.parse(decodeURIComponent(typeAndSubtypeFilters));
    }

    setCategoryFilters(parsedTypeSubtype);
    setFilters(urlFilter);
    setInputFilters(urlInputFilter);

  };

  const selectCategoryFilter = (type, selectedFilter) => {
    if (_.isEmpty(selectedFilter)) {
      setCategoryFilters(_.omit(categoryFilters, [type]))
    } else {
      setCategoryFilters({...categoryFilters, ...{ [type]: selectedFilter }})
    }
  };

  const selectFilter = (filter, selectedFilter) => {
    if (_.isEmpty(selectedFilter)) {
      setFilters(_.omit(filters, [filter]))
    } else {
      setFilters({...filters, ...{[filter]: selectedFilter }});
    }
  };

  const selectInputFilter = (filter, input) => {
    setInputFilters({...inputFilters, ...{[filter]: input }})
    setClearState(false)
  };

  const categoryOnClose = (type, subtype) => {
    selectCategoryFilter(type, _.without(categoryFilters[type], subtype));
  };

  const filterOnClose = (filter, selectedFilter) => {
    selectFilter(filter, _.without(filters[filter], selectedFilter));
  };

  const clearFilters = ({ openMainPage } = props) => {
    setFilters({});
    setCategoryFilters({});
    setInputFilters({});
    setClearState(true);
    openMainPage();
  };

  const closeFilter = () => props.goBack();

  const isSmallScreen = () => props.isSmallScreen;

  const getContainerStyle = ({isSmallScreen} = props) => {
    return isSmallScreen ? STYLES.mobileContainer : STYLES.desktopContainer;
  };
  
  const getSubtypeTags = () => {
    return (
      <div>
        {
          Object.keys(categoryFilters)
            .filter(type => !_.isEmpty(categoryFilters[type]))
            .map(type => {
            const subtypes = categoryFilters[type];
            return (
              <div key={`category-filter-${type}`}>
                <div className='active-filter-section'>
                  SUBTYPES
                </div>
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                  {
                    subtypes.map(subtype => {
                      return (
                        <FilterTag
                          key={`filter-tag-${subtype}`}
                          text={subtype}
                          onClose={() => categoryOnClose(type, subtype)}
                        />
                      )
                    })
                  }
                </div>
              </div>
            )
          })
        }
      </div>
    )
  };

  const getFilterTags = () => {
    return (
      <div>
        {
          Object.keys(filters)
            .filter(f => !_.isEmpty(filters[f]))
            .map(filter => {
              const selectedFilters = filters[filter];
              return (
                <div key={filter}>
                  <div className='active-filter-section'>
                    { filter.toUpperCase() }
                  </div>
                  <div style={{display: 'flex', flexWrap: 'wrap'}}>
                    {
                      selectedFilters.map(selectedFilter => {
                        return (
                          <FilterTag
                            key={selectFilter}
                            text={selectedFilter}
                            onClose={() => filterOnClose(filter, selectedFilter)}
                          />
                        )
                      })
                    }
                  </div>
                </div>
              )
            })
        }
      </div>
    )
  };

  const isClassificationChecked = (classification) => {
    return (filters[CLASSIFICATIONS_QUERY_PARAM] || []).includes(classification);
  };

  const isFilterChecked = (type, selectedFilter) => {
    return (filters[type] || []).includes(selectedFilter);
  };

  const handleClassificationClick = (classification) => {
    if (isClassificationChecked(classification)) {
      filterOnClose(CLASSIFICATIONS_QUERY_PARAM, classification);
    } else {
      const existingFilters = (filters[CLASSIFICATIONS_QUERY_PARAM] || []);
      selectFilter(CLASSIFICATIONS_QUERY_PARAM, [...existingFilters, classification]);
    }
  };

  return (
    <div style={getContainerStyle()}>
      <div style={{position: 'relative', display: 'flex', flexWrap: 'wrap', marginBottom: 8}}>
        {isSmallScreen()
          && (
            <div style={{height: 40}}>
              <div role="button" onClick={closeFilter} style={STYLES.closeBtn}>
                <CloseIcon color={LIGHT_GREY} style={STYLES.closeIcon} />
              </div>
            </div>
          )
        }
        <div
          role="button"
          onClick={ () => convertToUrl()}
          className='apply-filter-button'
          style={{background: secondaryColor }}
        >
          Apply Selection
        </div>
        <div style={{ width: '100%' }}>
          {
            !_.isEmpty(filters) || !_.isEmpty(categoryFilters) || !_.isEmpty(inputFilters)
              ? <div>
                  <div className='active-filter-type-title-text'>
                    Active Filters
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {
                      !_.isEmpty(filters)
                        ? getFilterTags()
                        : null
                    }
                    {
                      !_.isEmpty(categoryFilters)
                        ? getSubtypeTags()
                        : null
                    }
                  </div>
                  <div
                    onClick={ () => clearFilters()}
                    className='clear-filter-button'
                  >
                    Clear All Filters
                  </div>
                </div>
              : null
          }
        </div>
      </div>
      <div style={{ margin: '12px 0px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
          <PriceIcon
            viewBox={"0 0 21 21"}
            color={DARK_GREY}
          />
          <div className='filter-type-title-text'>
            Price
          </div>
        </div>
        <PriceFilter
          text="Max Price $"
          selectFilter={selectInputFilter}
          inputFilterType={'maxPrice'}
          urlFilter={inputFilters['maxPrice']}
          convertToUrl={convertToUrl}
          clearState={clearState}
          borderColor={secondaryColor}
        />
      </div>
      <div style={{ margin: '12px 0px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
          <PotencyIcon
            viewBox="0 0 21 24"
            color={DARK_GREY}
          />
          <div className='filter-type-title-text'>
            Potency
          </div>
        </div>
        <InputFilter
          text="Min THC % or mg"
          selectFilter={selectInputFilter}
          inputFilterType={'minThc'}
          urlFilter={inputFilters['minThc']}
          convertToUrl={convertToUrl}
          clearState={clearState}
          borderColor={secondaryColor}
        />
      </div>
      <div style={{ margin: '12px 0px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
          <div>
            <BrandTreezIcon
              viewBox={"0 0 18 22"}
              color={DARK_GREY}
            />
          </div>
          <div className='filter-type-title-text'>
            Brand
          </div>
        </div>
        <MultiSelectFilter
          isFilterChecked={isFilterChecked}
          filterOnClose={filterOnClose}
          filters={filters}
          selectFilter={selectFilter}
          filterType={'brands'}
          options={brands}
          color={secondaryColor}
        />
      </div>
      <div style={{ margin: '12px 0px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
          <div>
            <Flower color={DARK_GREY}/>
          </div>
          <div className='filter-type-title-text'>
            Type &amp; Subtype
          </div>
        </div>
        {
          _.slice(categories, 0, 3).map(({type, subtypes}) => (
            <CategoryFilter
              key={type}
              type={type}
              subtypes={subtypes}
              selectFilter={(selectedFilter) => selectCategoryFilter(type, selectedFilter)}
              filters={categoryFilters[type] || []}
              color={secondaryColor}
            />
          ))
        }
        {
          expandCategory
            ? _.slice(categories, 3, categories.length).map(({type, subtypes}) => (
                <CategoryFilter
                  key={type}
                  type={type}
                  subtypes={subtypes}
                  selectFilter={(selectedFilter) => selectCategoryFilter(type, selectedFilter)}
                  filters={categoryFilters[type] || []}
                  color={secondaryColor}
                />
              ))
            : null
        }
        <div
          onClick={() => setExpandCategory(!expandCategory)}
        >
          {
            expandCategory
              ? <div className='clickable'>
                  - Less
                </div>
              : <div className='clickable'>
                  + More
                </div>
          }
        </div>
      </div>
      <div style={{ margin: '12px 0px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
          <div>
            <ClassificationIcon
              viewBox='0 0 20 20'
              color={DARK_GREY}
            />
          </div>
          <div className='filter-type-title-text'>
            Classification
          </div>
        </div>
        {
          CLASSIFICATIONS_ALWAYS_DISPLAYED.map(classification => (
            <div key={classification} style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                style={{ color: secondaryColor }}
                checked={isClassificationChecked(classification)}
                onChange={() => handleClassificationClick(classification)}
              />
              <div
                className='clickable'
                onClick={() => handleClassificationClick(classification)}
              >
                { classification }
              </div>
            </div>
          ))
        }
        {
          expandClassifications
            ? classifications.filter(item => !CLASSIFICATIONS_ALWAYS_DISPLAYED.includes(item)).map(classification => (
                <div style={{display: 'flex', alignItems: 'center'}}>
                  <Checkbox
                    style={{ color: secondaryColor }}
                    checked={isClassificationChecked(classification)}
                    onChange={() => handleClassificationClick(classification)}
                  />
                  <div
                    className='clickable'
                    onClick={() => handleClassificationClick(classification)}
                  >
                    { classification }
                  </div>
                </div>
              ))
            : null
        }
        <div
          style={{cursor: 'pointer'}}
          onClick={() => setExpandClassifications(!expandClassifications)}
        >
          {
            expandClassifications
              ? <div className='clickable'>
                  - Less
                </div>
              : <div className='clickable'>
                  + More
                </div>
          }
        </div>
      </div>
      <div style={{ margin: '12px 0px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
          <div>
            <FlavorIcon
              viewBox={'0 0 36 25'}
              color={DARK_GREY}
              style={{overflow: 'visible'}}
            />
          </div>
          <div className='filter-type-title-text'>
            Flavor
          </div>
        </div>
        <MultiSelectFilter
          isFilterChecked={isFilterChecked}
          filterOnClose={filterOnClose}
          filters={filters}
          selectFilter={selectFilter}
          filterType={'flavors'}
          options={flavors}
          color={secondaryColor}
        />
      </div>
      <div style={{ margin: '12px 0px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
          <div>
            <EffectIcon
              viewBox='0 0 20 24'
              color={DARK_GREY}
            />
          </div>
          <div className='filter-type-title-text'>
            Effect
          </div>
        </div>
        <MultiSelectFilter
          isFilterChecked={isFilterChecked}
          filterOnClose={filterOnClose}
          filters={filters}
          selectFilter={selectFilter}
          filterType={'effects'}
          options={effects}
          color={secondaryColor}
        />
      </div>
      <div style={{ margin: '12px 0px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
          <div>
            <GeneralIcon
              viewBox='0 0 20 20'
              color={DARK_GREY}
            />
          </div>
          <div className='filter-type-title-text'>
            General
          </div>
        </div>
        <MultiSelectFilter
          isFilterChecked={isFilterChecked}
          filterOnClose={filterOnClose}
          filters={filters}
          selectFilter={selectFilter}
          filterType={'generals'}
          options={generalAttributes}
          color={secondaryColor}
        />
      </div>
    </div>
  );
};

export default withRouter(Filter);



// WEBPACK FOOTER //
// ./src/components/AdvancedFilter/Filter.jsx